export class HeaderLocation {
	element = document.querySelector('.header-location');
	activeClass = 'header-location--active';

	constructor() {
		this.init();
	}

	open = () => {
		this.element.classList.add(this.activeClass);
		window.addEventListener('click', this.windowClickHandler);
	};

	close = () => {
		this.element.classList.remove(this.activeClass);
		window.removeEventListener('click', this.windowClickHandler);
	};

	toggle = () => {
		if (this.element.classList.contains(this.activeClass)) this.close();
		else this.open();
	};

	windowClickHandler = ({ target }) => {
		if (!this.element.contains(target)) this.close();
	};

	clickHandler = ({ target }) => {
		if (target.closest('.header-location__current')) this.toggle();
	};

	init = () => {
		this.element.addEventListener('click', this.clickHandler);
	};
}
